export default __webpack_public_path__ + "static/media/invoicesEmpty.2574c507.svg";